import { render, staticRenderFns } from "./AdminConfig.vue?vue&type=template&id=792527a4&scoped=true&"
import script from "./AdminConfig.vue?vue&type=script&lang=js&"
export * from "./AdminConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792527a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792527a4')) {
      api.createRecord('792527a4', component.options)
    } else {
      api.reload('792527a4', component.options)
    }
    module.hot.accept("./AdminConfig.vue?vue&type=template&id=792527a4&scoped=true&", function () {
      api.rerender('792527a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminConfig.vue"
export default component.exports